import { render } from "./ProductHeader.vue?vue&type=template&id=5f7e8afa&scoped=true"
import script from "./ProductHeader.vue?vue&type=script&lang=js"
export * from "./ProductHeader.vue?vue&type=script&lang=js"

import "./ProductHeader.vue?vue&type=style&index=0&id=5f7e8afa&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7e8afa"],['__file',"webpack-assets/vue/templates/product/catalog/parts/ProductHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f7e8afa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f7e8afa', __exports__)) {
    api.reload('5f7e8afa', __exports__)
  }
  
  module.hot.accept("./ProductHeader.vue?vue&type=template&id=5f7e8afa&scoped=true", () => {
    api.rerender('5f7e8afa', render)
  })

}


export default __exports__